import { BaseModel } from './base';
import { IUsersData } from './users-data';
import { IVUsersCompletion } from './users-completion.view';
import { IUsersWorkHistory } from './users-work-history';
import { IUsersStatisticsSkills, IUsersStatisticsSkillsHistory, IUsersStatisticsSoftSkills, VQueryResultCloseView, VQueryResultConversationReceivedView, VQueryResultConversationView, VQueryResultOpenView, VQueryResultSpontaneousView, VQueryResultStepView, VQueryResultTop100View, VQueryResultTop10View, VQueryResultTop25View, VQueryResultTop50View, VUserMonthViewView } from './users-statistics';
import { VUserIncreaseCertificationView, VUserIncreaseCourseView, VUserIncreaseJobView, VUserIncreaseLanguageView, VUserIncreaseSkillView, VUserIncreaseStudyView } from './user-increase';

export interface IUsers extends BaseModel {
	username?: string;
	password?: string;
	status?: string;
	role?: string;
	subscriptionDate?: Date;
	privacy?: boolean;
	active?: boolean;
	data?: IUsersData;
	activeQueries?: number;
	availableQueries?: number;
	workHistories?: IUsersWorkHistory[];
	completion?: IVUsersCompletion;

	statisticsSkills?: IUsersStatisticsSkills[];
	statisticsSkillsHistory?: IUsersStatisticsSkillsHistory[];
	statisticsSoftSkills?: IUsersStatisticsSoftSkills[];

	userMonthViewViews?: VUserMonthViewView[];

	queryResultCloseViews?: VQueryResultCloseView[];
	queryResultOpenViews?: VQueryResultOpenView[];
	queryResultConversationViews?: VQueryResultConversationView[];
	queryResultConversationReceivedViews?: VQueryResultConversationReceivedView[];
	queryResultSpontaneousViews?: VQueryResultSpontaneousView[];
	queryResultStepViews?: VQueryResultStepView[];
	queryResultTop10Views?: VQueryResultTop10View[];
	queryResultTop25Views?: VQueryResultTop25View[];
	queryResultTop50Views?: VQueryResultTop50View[];
	queryResultTop100Views?: VQueryResultTop100View[];

	increaseJobs?: VUserIncreaseJobView[];
	increaseStudies?: VUserIncreaseStudyView[];
	increaseLanguages?: VUserIncreaseLanguageView[];
	increaseSkills?: VUserIncreaseSkillView[];
	increaseCertifications?: VUserIncreaseCertificationView[];
	increaseCourses?: VUserIncreaseCourseView[];
}

export const USERS_API: string = 'users';
